import { Form, Input } from '@arco-design/web-react'
import SettingSectionCard from '../SettingSectionCard'
import InstantSwitch from '../InstantSwitch'
import type { OptionsAPI } from '../useOptions'

const KEYS = ['EmailDomainRestrictionEnabled', 'EmailAliasRestrictionEnabled', 'EmailDomainWhitelist']

export default function EmailDomainSection({ options }: { options: OptionsAPI }) {
  const { get, patch } = options

  return (
    <SettingSectionCard
      title="邮箱域名白名单"
      subtitle="防止临时邮箱批量注册；白名单为逗号分隔域名"
      keys={KEYS}
      options={options}
    >
      <Form layout="vertical">
        <div className="grid md:grid-cols-2 gap-3">
          <Form.Item label="启用邮箱域名白名单">
            <InstantSwitch options={options} optionKey="EmailDomainRestrictionEnabled" />
          </Form.Item>
          <Form.Item label="启用邮箱别名限制">
            <InstantSwitch options={options} optionKey="EmailAliasRestrictionEnabled" />
          </Form.Item>
        </div>
        <Form.Item label="域名白名单" extra="逗号分隔，如 gmail.com,qq.com">
          <Input.TextArea
            value={get('EmailDomainWhitelist')}
            onChange={(v) => patch({ EmailDomainWhitelist: v })}
            autoSize={{ minRows: 3, maxRows: 8 }}
            placeholder="gmail.com, outlook.com"
          />
        </Form.Item>
      </Form>
    </SettingSectionCard>
  )
}
